import technicalIcon from '../../assets/images/homepage/chooseus/technical.svg';
import strategyIcon from '../../assets/images/homepage/chooseus/stratergy.svg';
import provenIcon from '../../assets/images/homepage/chooseus/proven.svg';
import officeImage from '../../assets/images/homepage/office.webp';
import vectorIcon from '../../assets/images/icons/vector.svg';
import starIcon from '../../assets/images/icons/staricon.svg';
import portfolioSolutionIcon from '../../assets/images/icons/protfoliosolution.svg';
import project1 from '../../assets/images/portfoliopage/gostorportfolio.webp';
import project2 from '../../assets/images/portfoliopage/rabbitxportfolio.webp';
import project3 from '../../assets/images/portfoliopage/cryptonaryportfolio.webp';
import project4 from '../../assets/images/portfoliopage/arbventureportfolio.webp';
import project5 from '../../assets/images/portfoliopage/tatvacareportfolio.webp';
import project6 from '../../assets/images/portfoliopage/ddxportfolio.webp';
import project7 from '../../assets/images/portfoliopage/medilearnportfolio.webp';
import fintechicon from '../../assets/images/industrypage/fintech.svg';
import healthcareicon from '../../assets/images/industrypage/healthcare.svg';
import saasicon from '../../assets/images/industrypage/saas.svg';
import fintech from '../../assets/images/industrypage/industryiconbg.webp';
import healthcare from '../../assets/images/industrypage/industryiconbg.webp';
import saas from '../../assets/images/industrypage/industryiconbg.webp';
import clinicalDocument from '../../assets/images/industrypage/ClinicalDocument.webp';
import patientEngagement from '../../assets/images/industrypage/PatientEngagement.webp';
import clinicalDecision from '../../assets/images/industrypage/ClinicalDecision.webp';
import healthAnalytics from '../../assets/images/industrypage/HealthAnalytics.webp';
import telehealthInfrastructure from '../../assets/images/industrypage/TelehealthInfrastructure.webp';

import highlightImage from '../../assets/images/industrypage/highlight.webp';
import architecture from '../../assets/images/technology/architecture.svg';
import test from '../../assets/images/technology/test.svg';
import security from '../../assets/images/technology/security.svg';
import documentation from '../../assets/images/technology/documentation.svg';
import reactIcon from '../../assets/images/icons/react.svg';
import angularJsIcon from '../../assets/images/icons/AngularJS.svg';
import reactNativeIcon from '../../assets/images/icons/reactnative.svg';
import nextJsIcon from '../../assets/images/icons/nextjs.svg';
import swiftIcon from '../../assets/images/icons/swift.svg';
import javaIcon from '../../assets/images/icons/java.svg';
import kotlinIcon from '../../assets/images/icons/Kotlin.svg';
import flutterIcon from '../../assets/images/icons/Flutter.svg';
import vueJsIcon from '../../assets/images/icons/vuejs.svg';
import makeIcon from '../../assets/images/developmentlanguage/make.svg';
import zapierIcon from '../../assets/images/developmentlanguage/zapier.svg';
import n8nIcon from '../../assets/images/developmentlanguage/n8n.svg';
import awsIcon from '../../assets/images/developmentlanguage/aws.svg';
import azureIcon from '../../assets/images/developmentlanguage/azure.svg';
import gcpIcon from '../../assets/images/developmentlanguage/googlecloud.svg';
import dockerIcon from '../../assets/images/developmentlanguage/docker.svg';
import kubernetesIcon from '../../assets/images/developmentlanguage/kubernetes.svg';
import terraformIcon from '../../assets/images/developmentlanguage/terraform.svg';
import nodeServiceIcon from '../../assets/images/developmentlanguage/node.svg';
import goServiceIcon from '../../assets/images/developmentlanguage/Go.svg';
import blogbg from '../../assets/images/developmentlanguage/blogbg.webp';
import contactUsAddressIcon from '../../assets/images/contactus/address.svg';
import contactUsCallIcon from '../../assets/images/contactus/call.svg';
import email from '../../assets/images/contactus/email.webp';
import mongodbIcon from '../../assets/images/developmentlanguage/mongodb.svg';
import mysqlIcon from '../../assets/images/developmentlanguage/mysql.svg';
import firebaseIcon from '../../assets/images/developmentlanguage/firebase.svg';
import redisIcon from '../../assets/images/developmentlanguage/redis.svg';
import fintechstep from '../../assets/images/industrypage/fintech_step.svg';

import ComplianceExpertise from '../../assets/images/industrypage/ComplianceExpertise.webp';

import mobileAppDevelopmentImage from '../../assets/images/servicepage/mobileDevelopment.svg';
import webAppDevelopmentImage from '../../assets/images/servicepage/webDevelopment.svg';
import apiIntegrationImage from '../../assets/images/servicepage/api_integration.svg';
import frontendpagebg from '../../assets/images/developmentlanguage/frontendpagebg.svg';
import backendPageImage from '../../assets/images/technology/backend_image.svg';
import databasePageImage from '../../assets/images/technology/database_image.svg';
import cloudPageImage from '../../assets/images/technology/cloud_image.svg';
import automationPageImage from '../../assets/images/technology/automation_image.svg';
import himanshuImage from '../../assets/images/team_images/himanshusir_image.webp';
import anjaliImage from '../../assets/images/team_images/anjaliBodepic.webp';
import rishabhImage from '../../assets/images/team_images/rishi.webp';
import shaliniImage from '../../assets/images/team_images/shalini.webp';
import pradipImage from '../../assets/images/team_images/Pradip.webp';
import tanishImage from '../../assets/images/team_images/Tanish.webp';
import bhumikaImage from '../../assets/images/team_images/Bhumika.webp';
import vikrantImage from '../../assets/images/team_images/Vikrant.webp';
import tusharImage from '../../assets/images/team_images/Tushar.webp';
import nishantImage from '../../assets/images/team_images/Nishant.webp';
import aryanImage from '../../assets/images/team_images/Aryan.webp';
import khushiImage from '../../assets/images/team_images/Khushi.webp';

const Constants = {

  statItems: [
    {
      num: '01',
      heading: 'Industry',
      data: [
        'Healthcare Technology',
         'Digital Health',
      ]
    },
    {
      num: '02',
      heading: 'Tag',
      data: [
        'AI-Powered Clinical',
       'Knowledge Platform for',
        'Doctors',
      ]
    },
    {
      num: '03',
      heading: 'Technology',
      data: [
        'React Native, React.js',
        'Node.js / Python',
        'MongoDB / PostgreSQL',
        'AWS / Firebase',
      ],
    },
  ],

  capsules: [
    {
      text: 'MVP Development',
      position: 'top-left',
      rotate: '-rotate-12 md:-rotate-17',
      arrowDir: 'right',
      arrowColor: '#EA8B30',
      iconPosition: 'top-right',
      bg: 'bg-[#EA8B30]/30'
    },
    {
      text: 'Product Ideation to Delivery',
      position: 'top-right',
      rotate: 'rotate-12 md:rotate-15',
      arrowDir: 'left',
      arrowColor: '#744DFF',
      iconPosition: 'top-right',
      bg: 'bg-[#4532C4]/30'
    },
    {
      text: 'Mobile apps to enhance user experience',
      position: 'bottom-left',
      rotate: '-rotate-12 md:-rotate-10',
      arrowDir: 'right',
      arrowColor: '#CC35C2',
      iconPosition: 'top-right',
      bg: 'bg-[#C02CDE]/30'
    },
    {
      text: 'Web Apps development to streamline processes',
      position: 'bottom-right',
      rotate: 'rotate-12 md:rotate-6',
      arrowDir: 'left',
      arrowColor: '#ED4D7F',
      iconPosition: 'top-right',
      bg: 'bg-[#ED4D7F]/10'
    }
  ],

  positionClasses: {
    'top-left': 'left-0 top-6 md:left-40 lg:left-48 xl:left-48 translate-x-0 -translate-y-1/2 md:translate-x-1',
    'top-right': 'right-0 top-20 md:right-0 lg:right-0 xl:right-0 translate-x-0 -translate-y-1/2 md:-translate-x-2',
    'bottom-left': 'left-0 bottom-0 md:left-0 lg:left-0 xl:left-0 translate-x-0 translate-y-1/2 md:translate-x-2',
    'bottom-right': '-right-10 -top-10'
  },

   stats: [
    {
      number: '25+',
      label: 'Engineers'
    },
    {
      number: '50+',
      label: 'Project Delivered'
    },
    {
      number: '10+',
      label: 'Years of Excellence'
    },
    {
      number: '3',
      label: 'Continents Served'
    }
  ],
  

  FullSpectrumTechnologyServices: [
    {
      title: "Frontend Development"
    },
    {
      title: "AI & Automation"
    },
    {
      title: "Backend Development"
    },
    {
      title: "Database"
    },
    {
      title: "Cloud & devops"
    },
  
  ],

  technoDetailServiceNames: [
    'Frontend Development',
    'Backend Development',
    'Database',
    'Cloud & DevOps',
    'AI & Automation',
  ],

  get frontendPageIntro() {
    return {
      hero: {
        backgroundAlt: 'frontend hero background',
        titleLines: [
          [{ text: 'A Complete Visual Layer' }],
          [
            { text: 'Built', emphasis: 'purple' as const },
            { text: ' For ' },
            { text: 'Performance', emphasis: 'purple' as const },
          ],
          [{ text: 'Precision And Scale' }],
        ],
      },
      scrollBannerText: 'Frontend Development',
      details: {
        serviceNames: this.technoDetailServiceNames,
        imageSrc: frontendpagebg,
        imageAlt: 'frontend development illustration',
        titleBefore: 'A Complete Visual Layer Built For Performance, Precision And Scale',
        titleGradient: '',
        titleAfter: '',
        description:
         "We craft pixel perfect frontend experiences that go far beyond good looks. Every interface we build is optimised for speed, accessibility, and seamless interaction whether it's a SaaS dashboard, a fintech portal, or a consumer-facing product. Our team works closely with your designers and backend engineers to deliver a frontend that feels native, loads fast, and holds up under real user behaviour. From component architecture to production deployment, we own the quality end to end.",
      },
    }
  },

  get backendPageIntro() {
    return {
      hero: {
        backgroundAlt: 'backend hero background',
        titleLines: [
          [
            { text: 'Enterprise Backend ' },
            { text: 'Architecture', emphasis: 'purple' as const },
            { text: ' That' },
          ],
          [
            { text: 'Handles Real Scale & Real ' },
            { text: 'Complexity', emphasis: 'purple' as const },
          ],
          [{ text: 'And Real Load' }],
        ],
      },
      scrollBannerText: 'Backend Development',
      details: {
        serviceNames: this.technoDetailServiceNames,
        imageSrc: backendPageImage,
        imageAlt: 'backend development illustration',
        titleBefore: 'Enterprise Backend Architecture That Handles Real Scale, Real Complexity And Real Load ',
        titleGradient: ' ',
        titleAfter: ' ',
        description: "Your backend is the foundation everything else is built on. We design and develop backend systems using Node.js, Python, and GoLang that are engineered to handle millions of requests without breaking. Our approach starts with clean API design, robust authentication, and security-first architecture, ensuring your data stays protected and your systems stay performant. We specialise in building backends for fintech platforms, healthcare applications, and high-traffic SaaS products where downtime costs real money. Every system we build includes comprehensive monitoring, automated testing, and documentation that lasts beyond the initial deployment. We don't just ship code, we ship reliability.",
      },
    }
  },

  get databasePageIntro() {
    return {  
      hero: {
        backgroundAlt: 'database hero background',
        titleLines: [
          [{ text: 'Database Design &' }],
          [
            { text: 'Optimization', emphasis: 'purple' as const },
            { text: ' That ' },
            { text: 'Grows', emphasis: 'purple' as const },
          ],
          [{ text: 'With Your Product, Never Against It' }],
        ],
      },
      scrollBannerText: 'Database',
      details: {
        serviceNames: this.technoDetailServiceNames,
        imageSrc: databasePageImage,
        imageAlt: 'database illustration',
        titleBefore: 'Database Design & Optimization That Grows With Your Product, Never Against It',
        titleGradient: '',
        titleAfter: ' ',
        description:
          "A well-designed database is invisible, it's fast, reliable, and just works. A poorly designed one becomes your biggest bottleneck. We design and optimise database systems using PostgreSQL, MongoDB, Redis, and Elasticsearch that are built to scale from your first user to your millionth. Our approach includes careful schema design, strategic indexing, query optimisation, and migration planning that doesn't require downtime. We work with fintech platforms handling millions of transactions and SaaS products managing complex relational data, understanding the specific requirements of your domain. We don't just set up a database and walk away. We document schema decisions, provide optimisation recommendations, and ensure your team can maintain it long-term with confidence.",
      },
    }
  },
  

  get cloudDevopsPageIntro() {
    return {
      hero: {
        backgroundAlt: 'cloud devops hero background',
        titleLines: [
          [
            { text: 'AWS, GCP & Azure ' },
            { text: 'Cloud', emphasis: 'purple' as const },
          ],
          [
            { text: 'Infrastructure', emphasis: 'purple' as const },
            { text: ' That Lets Your ' },
            { text: 'Team Ship' },
          ],
          [
            { text: 'Faster', emphasis: 'purple' as const },
            { text: ', Break Less' },
          ],
        ],
      },
      scrollBannerText: 'Cloud & DevOps',
      details: {
        serviceNames: this.technoDetailServiceNames,
        imageSrc: cloudPageImage,
        imageAlt: 'cloud and devops illustration',
        titleBefore: 'AWS, GCP & Azure Cloud Infrastructure That Lets Your Team Ship Faster, Break Less ',
        titleGradient: ' ',
        titleAfter: ' ',
        description:
          "Good infrastructure is invisible. Bad infrastructure takes down your product at 3 AM. We build and manage cloud infrastructure on AWS, GCP, and Azure that's reliable, cost-efficient, and doesn't require a single person who knows all the secrets. Our DevOps practice covers environment setup, containerisation with Docker and Kubernetes, CI/CD pipeline automation, and comprehensive monitoring. We set up the pipelines so every code commit is automatically tested, built, and ready for production, removing the manual steps that introduce errors. From initial architecture through ongoing optimisation, we focus on observability, cost control, and documentation that persists when team members leave. Yo"
      },
    }
  },

  get automationPageIntro() {
    return {  
      hero: {
        backgroundAlt: 'automation hero background',
        titleLines: [
          [
            { text: 'Workflow & ' },
            { text: 'Automation', emphasis: 'purple' as const },
          ],
          [
            { text: 'Business Process That ' },
            { text: 'Optimization', emphasis: 'purple' as const },
          ],
          [{ text: 'Eliminates Manual Work' }],
        ],
      },
      scrollBannerText: 'AI & Automation',
      details: {
        serviceNames: this.technoDetailServiceNames,
        imageSrc: automationPageImage,
        imageAlt: 'automation illustration',
        titleBefore: 'Workflow Automation & Business Process Optimization That Eliminates Manual Work',
        titleGradient: ' ',
        titleAfter: ' ',
        description:
          "Every company has repetitive work that's quietly costing thousands in lost productivity every month. We design and build automation systems that eliminate manual tasks across your organisation, from data entry to report generation to cross system synchronisation. Using n8n, Make.com, and custom automation pipelines, we map your existing workflows, identify inefficiencies, and build systems that run reliably in the background without human intervention. Crucially, every automation we build includes proper error handling, alerting, and fallback processes because automation that fails silently is worse than no automation at all. We focus on automation that delivers measurable ROI within weeks, not months. Your team gets back the time they were spending on repetitive work, and can focus on what actually moves the business forward."
      },
    }
  },

  frontendServices: [
    { title: 'React', icon: reactIcon },
    { title: 'AngularJS', icon: angularJsIcon },
    { title: 'React Native', icon: reactNativeIcon },
    { title: 'Next.Js', icon: nextJsIcon },
    { title: 'Swift', icon: swiftIcon },
    { title: 'Java', icon: javaIcon },
    { title: 'Kotlin', icon: kotlinIcon },
    { title: 'Flutter', icon: flutterIcon },
    { title: 'Vue.Js', icon: vueJsIcon },
  ],

   chooseUsCards: [
    {
      title: 'Technical Excellence',
      description: "Our 25+ engineers bring deep expertise across modern technology stacks. We don't just write code, we architect solutions built for scale, security, & long-term maintainability.",
      image: technicalIcon
    },
    {
      title: 'Strategic Partnership',
      description: 'We view ourselves as an extension of your team, not just a vendor. From initial strategy to final deployment, we’re invested in your success.',
      image: strategyIcon
    },
    {
      title: 'Proven Delivery',
      description: "From MVPs to enterprise platforms, we've delivered 50+ projects across fintech, healthcare, & SaaS. Our structured methodology ensures on-time, on-budget delivery.",
      image: provenIcon
    }
  ],

   industries: [
    {
      title: "",
      description: ""
    },
    {
      title: "Fintech & Banking",
      description: "PCI-DSS compliant systems, payment integrations, regulatory reporting"
    },
    {
      title: "SaaS & Startups",
      description: "MVP development, product scaling, technical due diligence support"
    },
    {
      title: "Healthcare & Wellness",
      description: "HIPAA-ready platforms, telehealth solutions, health data analytics"
    }
  ],

   portfolioData: [
    {
      image: project2,
      title: 'RabbitX',
      description: 'Smart Crypto Trading Experience',
      link: '/portfolio/rabbitx'
    },
  {
    image: project3,
    title: 'Cryptonary',
    description: 'Simplifying Crypto Markets with Intelligent Data & Analytics',
    link: '/portfolio/cryptonary'
  },
  {
    image: project1,
    title: 'Gostor',
    description: 'Discover, Shop & Earn in One Platform',
    link: '/portfolio/gostor'
  },
  {
    image: project4,
    title: 'ARB Ventures',
    description: 'Real Estate Management Platform',
    link: '/portfolio/arbventure'
  },
  {
    image: project5,
    title: 'Tatva care',
    description: 'Real Estate Management Platform',
    link: '/portfolio/tatvacare'
  },
  {
    image: project6,
    title: 'DDX',
    description: 'AI-Powered Clinical',
    link: '/portfolio/ddx'
  },
  {
    image: project7,
    title: 'Medilearn',
    description: 'AI-Powered Clinical',
    link: '/portfolio/medilearn'
  },

],

portfolioProjectCards: [
  {
    image: project1,
    name: 'Gostor',
    tagline: 'Discover, Shop & Earn in One Platform',
    tag: 'E-Commerce',
    description:
      'A powerful crypto market platform that helps users track, analyze, and manage digital assets in real time. It offers smart insights, portfolio tracking, and easy-to-use dashboards across both mobile app and web.',
  },
  {
    image: project2,
    name: 'RabbitX',
    tagline: 'Smart Crypto Trading Experience',
    
    tag: 'Fintech',
    description:
      'Built for fast-moving crypto teams, this platform centralizes market data, watchlists, and portfolio analytics to support faster, more informed decisions across devices.',
  },
  {
    image: project3,
    name: 'Cryptonary',
    tagline: 'Better Care Through Connected Workflows',
    hideHeroText: true,
    tag: 'Fintech',
    description:
      'A modern healthcare operations suite designed to streamline communication, automate repetitive tasks, and improve patient-facing outcomes with a clean, scalable experience.',
  },
  {
    image: project4,
    name: 'ARB Ventures',
    tagline: 'Real Estate Management Platform',
    hideHeroText: true,
    tag: 'Real Estate',
    description:
    'ARB Venture is a modern real estate networking app that connects buyers, sellers, and investors through seamless property discovery and collaboration.',
  },
  {
    image: project5,
    name: 'Tatva care',
    tagline: 'Real Estate Management Platform',
    hideHeroText: true,
    tag: 'Healthcare',
    description:
    'Tatva AI is a generative AI platform for doctors that provides medical Q&A and research-backed insights from sources like PubMed.',
  },
  {
    image: project6,
    name: 'DDX',
    tagline: 'Real Estate Management Platform',
    hideHeroText: true,
    tag: 'AI in Healthcare',
    description:
    'An AI-powered healthcare assistant app that helps doctors generate differential diagnoses, manage remote care, and analyze patient symptoms smarter and faster.',
  },
  {
    image: project7,
    name: 'Medilearn',
    tagline: 'Real Estate Management Platform',
    hideHeroText: true,
    tag: 'AI in Healthcare',
    description:
    'MediLearn AI is an AI-powered medical education app designed to simplify learning through interactive case studies, smart conversations, and domain-based clinical insights.',
  },
],

industryDetailsCards: [
  {
    image: fintech,
    icon: fintechicon,
    title: 'Fintech & Banking',
    intro:
      'Financial technology operates under intense scrutiny. Regulators watching every transaction. Customers expecting flawless service. Fraudsters probing every vulnerability. The Coding Studio builds AI automation that performs under this pressure - systems designed from the ground up for security, compliance, and scale.',
    focusHeading: 'What We Build:',
    focusText:
      'ML-powered systems that identify fraudulent patterns in real-time-catching what rule-based approaches miss while minimizing false positives that frustrate legitimate customers. We build models trained on your transaction patterns, continuously learning and adapting to emerging threats.',
    cta: 'VIEW DETAILS',
  },
  {
    image: healthcare,
    icon: healthcareicon,
    title: 'Healthcare & Wellness',
    intro:
    'Healthcare technology carries unique responsibility. Patient data that must remain private. Clinical workflows that cannot afford errors. Systems that practitioners must trust completely. The Coding Studio builds AI automation that earns that trust - engineered for the specific demands of healthcare delivery.',
    focusHeading: 'What We Build:',
    focusText:
      'Intelligent processing of medical records, prescriptions, lab reports, and clinical notes. Automated extraction, classification, and routing - reducing administrative burden by 40%+ while maintaining accuracy that clinical teams can rely on.',
    cta: 'VIEW DETAILS',
  },
  {
    image: saas,
    icon: saasicon,
    title: 'SaaS & Startups',
    intro:
      "Startups move fast but can't afford to cut corners on architecture. We help funded startups build products that scale from first user to first million — without the technical debt that kills growth.",
    focusHeading: 'What We Build:',
    focusText:
      'MVP development, Multi-tenant SaaS platforms, Product scaling and optimization, API-first architectures, Integration marketplace development, Usage-based billing systems',
    cta: 'COMING SOON',
  },
],


healthcareDetailsItems: [
  {
    image: clinicalDocument,
    title: 'Clinical Document Automation',
    description:
      'Intelligent processing of medical records, prescriptions, lab reports, and clinical notes. Automated extraction, classification, and routing - reducing administrative burden by 40%+ while maintaining accuracy that clinical teams can rely on.',
  },
  {
    image: patientEngagement,
    title: 'Patient Engagement Platforms',
    description:
      'Secure portals and mobile applications that connect patients with their care teams. Appointment scheduling, prescription refills, secure messaging, health record access - designed for accessibility and built for privacy.',
  },
  {
    image: clinicalDecision,
    title: 'Clinical Decision Support',
    description:
      'AI-powered tools that surface relevant information when clinicians need it. Drug interaction alerts, diagnosis suggestions, treatment protocol recommendations - augmenting clinical judgment without replacing it.',
  },
  {
    image: healthAnalytics,
    title: 'Health Analytics',
    description:
      'Population health dashboards, outcome analysis, and predictive models. Transform clinical data into insights that improve care quality, optimize operations, and support value-based care initiatives.',
  },
  {
    image: telehealthInfrastructure,
    title: 'Telehealth Infrastructure',
    description:
      'Secure video consultation platforms integrated with EHR systems, scheduling, and billing. Built for clinical workflow - not adapted from consumer video chat.',
  },
],

fintechExpertiseCards: [
  {
    title: 'PCI-DSS Level 1',
    description:
      'Secure payment processing and cardholder data protection at the highest certification level',
  },
  {
    title: 'RBI Guidelines',
    description: 'Digital lending, Payment aggregator, NBFC compliance',
  },
  {
    title: 'ISO 27001',
    description: 'Information security management and data protection',
  },
],

healthcareComplianceExpertise: {
  heading: 'Compliance Expertise',
  centerImage: ComplianceExpertise,
  topCards: [
   
    {
      title: 'HIPAA',
      points: [
        'Protected health information handling',
        'Minimum necessary access',
        'Audit controls',
      ],
    },
    {
      title: 'DPDP Act',
      points: [
        'Patient consent management',
        'Privacy by design',
        'Data localization',
      ],
    },
 
  ],
  bottomCards: [
    {
      title: 'ABDM Integration',
      points: [
        'Ayushman Bharat Digital Mission connectivity',
        'Health ID linking',
        'ABHA ID',
      ],
    },
    {
      title: 'Clinical Data Security',
      points: [
        'Encryption at rest & in transit',
        'Access logging',
        'Intrusion detection',
      ],
    },
    
   
  ],
},

healthcareCaseHighlight: {
  highlightImage: highlightImage,
  title: 'Case Highlight',
  body:
    'We engineered an AI automation system for a leading Indian healthcare company that reduced manual processing effort by 40%. The platform handles thousands of daily transactions with full compliance - a partnership that continues today because we deliver results that compound over time.',
  bodySecondary:
    "Our ongoing relationship with one of India's top healthcare organizations demonstrates what we mean by partnership: we are not a vendor they call when something breaks - we are the technology team they trust to build what matters.",
},
servicePage: {
  hero: {
    titleLines: ['AI Automation Services for', 'Regulated Industries'],
    description:
      'We deliver end-to-end AI automation that transforms healthcare deployment and ongoing optimization. Every engagement is tailored to your industry and business specific constraints and objectives: compliance requirements, technical constraints, and business objectives. No templates.',
  },
  intelligentAutomation: {
    badgeText: 'AI-AUTOMATION',
    titleLines: ['Intelligent Automation', 'Services'],
    features: [
      {
        title: 'Document Intelligence',
        description:
          'Automated extraction, classification, and processing of critical documents. From loan applications to medical records, we build pipelines that achieve 99%+ accuracy while maintaining complete audit trails. OCR, NLP, and custom ML models trained on your document types.',
      },
      {
        title: 'Predictive Analytics',
        description:
          'Custom ML models that drive decision making. Fraud detection systems that catch patterns rule-based approaches miss. Risk scoring that adapts to emerging threats. Patient outcome prediction that enables proactive intervention. We build intelligence that surfaces insights humans can act on.',
      },
      {
        title: 'Workflow Orchestration',
        description:
          'End-to-end automation that connects disparate systems, eliminates manual handoffs, and routes without degradation. We design workflows that handle exceptions gracefully, integrate with legacy infrastructure, and provide visibility at every step.',
      },
      {
        title: 'Conversational AI',
        description:
          'Domain-specific chatbots and virtual assistants that understand context, handle complex queries, and escalate as needed. Built with enterprise security, trained on your terminology, and designed to augment human capability rather than replace human judgment.',
      },
    ],
  },
  techFoundation: {
    title: 'Technology Foundation',
  },
  development: {
    badgeText: 'DEVELOPMENT',
    titleLines: ['Application Development'],
    
    imageItems: [
      {
        alt: 'Mobile App Development',
        image: mobileAppDevelopmentImage,
      },
      {
        alt: 'API Integration',
        image: apiIntegrationImage,
      },
      {
        alt: 'Web Application Development',
        image: webAppDevelopmentImage,
      },
    ],
    textItems: [
      {
        title: ['Mobile', 'Development'],
        body:
          'Cross-platform and native mobile applications that perform beautifully on every device. React Native and Flutter for efficient cross-platform delivery; Swift and Kotlin when native performance is non-negotiable. Every app built with offline capability, security hardening, and seamless backend integration.',
      },
      {
        title: ['Web Application', 'Development'],
        body:
          'Enterprise web applications built for scale, security, and longevity. We architect systems that handle millions of transactions, maintain subsecond response times, and evolve gracefully as requirements change. React, Next.js, Node.js, Python - chosen based on your specific needs, not our preferences.',
      },
      {
        title: ['API & Integration', 'Engineering'],
        body:
          'RESTful and GraphQL APIs designed for developer experience and system reliability. Third-party integrations that work-payment gateways, healthcare systems, financial data providers. We have connected to APIs others said were impossible.',
      },
    ],
    desktopColumnIndexes: [
      [0, 3],
      [1, 4],
      [2, 5],
    ],
  },
  consulting: {
    badgeText: 'CONSULTING',
    titleLines: ['Technical Consulting'],
    advisoryCards: [
      {
        title: ['Architecture', 'Review'],
        body: 'Deep-dive assessment of existing systems with actionable recommendations. We identify technical debt, security vulnerabilities, scalability bottlenecks, and compliance gaps - then provide a prioritized roadmap for addressing them.',
      },
      {
        title: ['CTO', 'Advisory'],
        body: 'Fractional technical leadership for organizations that need senior expertise without full-time cost. Architecture decisions, vendor evaluation, team structure, technology strategy - Himanshu and senior team members available on a retainer basis.',
      },
      {
        title: ['Compliance', 'Consulting'],
        body: 'Technical guidance on meeting PCI-DSS, HIPAA, RBI, DPDP Act, and other regulatory requirements. We have been through audits. We know what regulators look for. We will help you build systems that pass the first time.',
      },
    ],
    engagementHeading: 'Engagement Models',
    engagementCards: [
      {
        title: 'Project-Based',
        body: 'Defined scope, fixed timeline, clear deliverables. Best for organizations with well-understood requirements and specific outcomes in mind. Typical duration: 3-9 months.',
      },
      {
        title: 'Dedicated Team',
        body: 'Embedded engineering team that functions as an extension of your organization. Ongoing collaboration, continuous delivery, retained context. Best for long-term product development and platform evolution.',
      },
    ],
  },

},

 blogData: [
  {
    title: "Marketing 1",
    description: "The complete guide technical on-page optimization",
    image: officeImage,
    link: "/project1"
  },
  {
    title: "Marketing 2",
    description: "The complete guide technical on-page optimization",
    image: officeImage,
    link: "/project1"
  },
  {
    title: "Marketing 3",
    description: "The complete guide technical on-page optimization",
    image: officeImage,
    link: "/project1"
  },
  {
    title: "Marketing 4",
    description: "The complete guide technical on-page optimization",
    image: officeImage,
    link: "/project1"
  },
  {
    title: "Marketing 5",
    description: "The complete guide technical on-page optimization",
    image: officeImage,
    link: "/project1"
  },
  {
    title: "Marketing 6",
    description: "The complete guide technical on-page optimization",
    image: officeImage,
    link: "/project1"
  },
  {
    title: "Marketing 7",
    description: "The complete guide technical on-page optimization",
    image: officeImage,
    link: "/project1"
  },
  {
    title: "Marketing 8",
    description: "The complete guide technical on-page optimization",
    image: officeImage,
    link: "/project1"
  },        
],

blogPageFilterButtons: [
  'All Blog',
  'AI Technology',
  'Cyber Security',
  'IT Agency',
],

blogPageCards: [
  {
    slug: 'cyber-security-ai-1',
    image: blogbg,
    category: 'By Techto   ',
    date: 'February 3, 2025',
    heading: 'A New Era Of Cyber Security With AI',
    description: 'Techto February 3, 2025 technology 0 Adopt Zero Trust across the network Consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore of magna aliqua.....',
  },
  {
    slug: 'cyber-security-ai-2',
    image: blogbg,
    category: 'By Techto   ',
    date: 'February 3, 2025',
    heading: 'A New Era Of Cyber Security With AI',
    description: 'Techto February 3, 2025 technology 0 Adopt Zero Trust across the network Consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore of magna aliqua.....',
  },
  {
    slug: 'cyber-security-ai-3',
    image: blogbg,
    category: 'By Techto   ',
    date: 'February 3, 2025',
    heading: 'A New Era Of Cyber Security With AI',
    description: 'Techto February 3, 2025 technology 0 Adopt Zero Trust across the network Consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore of magna aliqua.....',
  },
  {
    slug: 'cyber-security-ai-4',
    image: blogbg,
    category: 'By Techto   ',
    date: 'February 3, 2025',
    heading: 'A New Era Of Cyber Security With AI',
    description: 'Techto February 3, 2025 technology 0 Adopt Zero Trust across the network Consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore of magna aliqua.....',
  },
 
],

blogDetailArticle: {
  introStrip: 'Technology',
  introMeta: 'By Techto — February 3, 2025',
  introHeading: 'A New Era Of Cyber Security With AI',
  introSubline:
    'How artificial intelligence is reshaping threat detection, response workflows, and the way security teams prioritize risk across modern infrastructure.',
  paragraphsAfterIntro: [
    `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.`,
    `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.`,
  ],
  inlineImages: [blogbg, blogbg],
  midHeading: 'Zero trust as the default posture',
  midParagraph:
    `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book.`,
  quoteIcon: starIcon,
  quoteParagraph:
    `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book.`,
  quoteAuthor: 'Jordan Lee — Principal Security Architect',
  closingParagraphs: [
   `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.`,
   `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.`,
  ],
},

contactUsSection: {
  faqItems: [
    {
      id: '01',
      question: 'What best describes your organization?',
      answers: [
        'Fintech/Financial Services',
        'Healthcare/Life Sciences',
        'SaaS/Technology',
        'Other',
      ],
    },
    {
      id: '02',
      question: 'What are you looking to accomplish?',
      answers: [
        'Build AI/Automation Solution',
        'Develop Web/Mobile Application',
        'Technical Consulting/Advisory',
        'Scale Existing Platform',
        'Other',
      ],
    },
    {
      id: '03',
      question: 'Approximate Budget Range',
      answers: [
        'Under 15 Lakhs',
        '15-50 Lakhs',
        '50 Lakhs - 1 Crore',
        'Above 1 Crore',
        'Let us Discuss',
      ],
    },
    {
      id: '04',
      question: 'Tell us about your project or challenge (textarea)',
      answers: [
        'What are you trying to build?',
        'What challenges are you facing?',
        'What would success look like?',
      ],
    },
  ],
  infoItems: [
    {
      title: 'Office Address',
      description: '438, The Boulevard, Near Pratham Circle, Gallaria Street Green City Road, Pal, Adajan, Surat, Gujarat 395009',
      icon: contactUsAddressIcon,
    },
    {
      title: 'Make A Call',
      description: '+917990345580',
      icon: contactUsCallIcon,
    },
    {
      title: '24/7 Online Support',
      description: 'inquire@thecodingstudio.in',
      icon: email,
    },
  ],
},

messageSection: {
  header: 'Send A Message',
  description: 'Write Us Something sending a message',
  namePlaceholder: 'Your Name',
  emailPlaceholder: 'Your Email',
  subjectPlaceholder: 'Select Subject',
  subjects: [
    'Frontend Development',
    'Mobile Development',
    'AI and Automation',
    'Technical Consulting'
  ],
  submitText: 'Send Message'
},

questionsSection: {
  header: 'FREQUENTLY ASKED QUESTIONS',
  items: [
    {
      question: 'What does TheCoding Studio actually do?',
      answer: `We build software. Web apps, mobile apps, AI systems, 
automation tools for startups and companies that need 
things built properly and shipped on time. We also run 
training programs for developers who want to level up 

their skills and work on real-world projects.`
    },
    {
      question: ' Who do you work with?',
      answer: `Two kinds of people come to us. Companies that need a 
reliable engineering team to build or scale their product. 
And developers who want to work on meaningful projects, 
sharpen their skills, or transition into a new area of tech. 
If you're either of those, you're in the right place.`
    },
    {
      question: 'Where are you based and do you work internationally?',
      answer: `We're based in India with a team that works across time 
zones. Our clients are spread across the US, UK, EU, and 
Southeast Asia. Remote-first is how we've always operated 
 so geography has never been a barrier for us or the 
people we work with.`
    },
    {
      question: 'How do I get started as a client?',
      answer: `Just reach out and tell us what you're trying to build. 
We'll set up a quick call to understand your requirements, 
and from there we'll put together a clear scope and timeline 
before anything else happens. No long intake forms, 
no commitment required to have the first conversation.`
    },
    {
      question: ' How do I join the team or apply for a role?',
      answer: `Head to the Careers page to see open positions. If nothing 
fits right now but you think you'd be a good match, send 
us a message anyway, we keep strong candidates in mind 
for future roles. We look for people who take ownership, 
communicate clearly, and care about the quality of what 
they ship.`
    },
    {
      question: ' What technologies do you work with?',
      answer: `Our core stack covers React, Next.js, Node.js, Python, 
React Native, and cloud infrastructure on AWS and GCP. 
For AI and ML work we use PyTorch, LangChain, and 
OpenAI integrations. We choose tools based on what the 
project needs, not what's trending. If you have specific 
technology requirements, we're happy to discuss them.`
    },
    {
      question: 'Do you offer internships or training programs?',
      answer: `Yes. Our Upskill program is built for developers who want 
structured, hands-on training in areas like full-stack 
development, AI/ML, and cloud. It's not a classroom course 
— you work on real problems with senior engineers. Check 
the Upskill page for current programs and intake dates.`
    },
    {
      question: 'How long does a typical project take?',
      answer: `Most projects run between 4 and 12 weeks depending on 
scope. Smaller builds and MVPs tend to be on the shorter 
end. Larger platforms or products with multiple integrations 
take longer. We always agree on a timeline upfront — and 
we stick to it.`
    },
    {
      question: 'Do you sign NDAs?',
      answer: `Yes, always. If you're sharing details about your product 
or business with us, we sign an NDA before that 
conversation happens. We work with a lot of companies 
building in competitive spaces and we treat everything 
we hear with full confidentiality.`
    },
    {
      question: 'How do I get in touch?',
      answer: `Hit the "Get in Touch" button at the top of the page. 
Whether you have a project in mind, a question about 
working with us, or just want to explore what's possible 
— we respond to every message, usually within 24 hours.`
    },
  ]
},

readyToBuildSection: {
  header: 'Ready to Build Something Remarkable?',
  description:
    "Let's discuss how The Coding Studio can accelerate your digital initiatives. Schedule a free consultation with our technical leadership team.",
  primaryButtonText: 'Schedule Consultation',
  secondaryButtonText: 'Download Our Capabilities Deck',
  image: "/webp/light.png"
},

testimonialsData: [
  {
    logo: vectorIcon,
    description: "Great Job by TheCodingStudio, totally enjoyed working with them.",
    star: starIcon,
    name: "Sophronia Mckenzie",
  },
  {
    logo: vectorIcon,
    description:
      "TheCodingStudio is a great app development company, who are easy to work with. They had high standards for work, quality of code and adhered to schedule well. They were flexible and arranged more time to help us meet deadlines. They made sure to send status every day and inform of possible blockers beforehand. I would rehire them for all my future app projects.",
    star: starIcon,
    name: "Pavan Sinha",
  },
  {
    logo: vectorIcon,
    description:
      "Took the brief and actioned it immediately, kept me involved at every step of the process. Will definitely work with TheCodingStudio again!",
    star: starIcon,
    name: "Jeremy",
  },
  {
    logo: vectorIcon,
    description:
      "Great Job by TheCodingStudio, totally enjoyed working with them. It was the right time and right place 😃 Will continue wherever possible.",
    star: starIcon,
    name: "Daniel",
  },
  {
    logo: vectorIcon,
    description:
      "TheCodingStudio helped build my MVP frontend and it was amazing. They understood my users and worked with me to derive the right set of requirements for the build. They are easy to work with and follow instructions well. I will hire them again.",
    star: starIcon,
    name: "Atif M.",
  },
  {
    logo: vectorIcon,
    description:
      "TheCodingStudio did a fantastic job for my app. Will hire again in future, highly recommended!",
    star: starIcon,
    name: "Prasanna R.",
  },
],

upskillTestimonialsData: [
  {
    logo: vectorIcon,
    description: 'The AI/ML course transformed my career. Got placed at Google within 3 months of completion!',
    star: starIcon,
    name: 'Priya Sharma',
    roleAtCompany: 'ML Engineer at Google',
    program: 'AI/ML Mastery',
    ctc: '₹35 LPA',
    emoji: '👩‍💻',
  },
  {
    logo: vectorIcon,
    description: 'Best investment I made! The mentorship and projects made me job-ready. Now at Amazon!',
    star: starIcon,
    name: 'Rahul Verma',
    roleAtCompany: 'Full Stack Developer at Amazon',
    program: 'Full Stack Development',
    ctc: '₹28 LPA',
    emoji: '🧑‍💼',
  },
  {
    logo: vectorIcon,
    description: 'System design course was exceptional. Cracked Microsoft L4 interview confidently!',
    star: starIcon,
    name: 'Ananya Patel',
    roleAtCompany: 'Backend Engineer at Microsoft',
    program: 'Backend Engineering',
    ctc: '₹32 LPA',
    emoji: '👨‍💻',
  },
],


 aboutUsSteps: [
  {
    title: 'Craft Over Speed:',
    description:
      `We believe in building things right the first time. Clean architecture, comprehensive testing, & thoughtful design aren't luxuries—they're requirements.`,
  },
  {
    title: 'Radical Transparency:',
    description:
      `No hidden surprises. We communicate early and often, share both progress and problems, and treat our clients as true partners.`,
  },
  {
    title: 'BuContinuous Learning:ild',
    description:
      `Technology evolves daily. We invest heavily in our team's growth through training, conferences, and dedicated learning time.`,
  },
  {
    title: 'Client Success:',
    description:
      `Your success is our success. We measure ourselves not by hours logged but by outcomes delivered.`,
  },
],

expertTeam: [
  { image: himanshuImage, name: 'Himanshu Goswami', role: 'CEO' },
  { image: anjaliImage, name: 'Anjali Bode', role: 'COO' },
  { image: rishabhImage, name: 'Rishabh Goswami', role: 'CMO' },
  { image: shaliniImage, name: 'Shalini Goswami', role: 'PMO' },
  { image: pradipImage, name: 'Pradip Vadchhak', role: 'Senior Full Stack Engineer' },
  { image: tanishImage, name: 'Tanish Jain', role: 'Senior Full Stack Engineer' },
  { image: bhumikaImage, name: 'Bhumika Mehta', role: 'Senior Full Stack Engineer' },
  { image: vikrantImage, name: 'Vikrant Ghodvinde', role: 'Senior Mobile Engineer' },
  { image: aryanImage, name: 'Aryan Meena', role: 'Backend Engineer' },
  { image: nishantImage, name: 'Nishant Kumar', role: 'Backend Engineer' },
  { image: tusharImage, name: 'Tushar Goswami', role: 'Frontend Engineer' },
  { image: khushiImage, name: 'Khushi Bhadani', role: 'UI/UX Designer' },
],

workFirstSectionCards: [
  {
    heading: 'AI/ML Engineers',
    points: ['Custom model development', 'MLOps', 'production ML systems'],
  },
  {
    heading: 'Backend Architects',
    points: ['High-throughput systems', 'microservices', 'API design'],
  },
  {
    heading: 'Full-Stack Engineers',
    points: ['End-to-end delivery', 'React', 'Node.js, Python'],
  },
  {
    heading: 'Mobile Specialists',
    points: ['React Native', 'Flutter', 'native iOS/Android'],
  },
  {
    heading: 'DevOps & Security',
    points: ['Cloud infrastructure', 'CI/CD', 'security-first operations'],
  },
],

workSecondSectionCards: [
  {
    heading: 'Compliance-First Architecture',
    text: 'We do not treat compliance as a final checklist before deployment. Every system we build starts with regulatory requirements mapped, data flows documented, and security architecture designed. Compliance is foundational, not optional.',
  },
  {
    heading: 'Accountable Engineering',
    text: 'We own our work. When something breaks, we fix it immediately and without excuses. When we make mistakes, we acknowledge them, learn from them, and ensure they do not repeat. Accountability is not a policy. It is how we operate.',
  },
  {
    heading: 'Transparent Communication',
    text: 'No surprises. You will know project status, potential risks, and honest timelines, not what you want to hear. We would rather have a difficult conversation early than a disaster later. Our clients trust us because we have earned that trust through radical honesty.',
  },
  {
    heading: 'Long-Term Thinking',
    text: 'We build systems designed to evolve, not just deploy. Clean architecture. Comprehensive documentation. Knowledge transfer that does not leave you dependent on us. We succeed when our clients have options, even if that means they could leave.',
  },
],

whyEngineerCards: [
  {
    heading: 'Senior-Level Environment :',
    description:
      'Everyone on our team has 3+ years of production experience. You will work alongside practitioners, not babysit juniors. Technical discussions assume competence. Code reviews focus on architecture, not syntax.',
  },
  {
    heading: 'Meaningful Work :',
    description:
      'You will build AI systems for healthcare companies. Payment platforms that process real money. Automation that handles compliance in industries where mistakes have consequences. Not CRUD apps. Not throwaway MVPs. Systems that matter.',
  },
  {
    heading: 'Competitive Compensation :',
    description:
      'Market-leading salaries for experienced engineers. We are competing for talent with the best companies in India - and we compensate accordingly.',
  },
  {
    heading: 'Founder-Led Culture :',
    description:
      'Himanshu remains hands-on - reviewing architectures, making technical decisions, setting standards. You will learn from someone with 10+ years of engineering leadership, not report to management layers removed from the work.',
  },
],

qualitiesSection: {
  heading: 'What We Look For',
  circleLabel: 'qualities',
  cards: [
    {
      description:
        'Minimum 3 years of production engineering experience',
    },
    {
      description:
        'Track record of shipping systems that run in production',
    },
    {
      description:
        'Communication skills that work in async, distributed environment',
    },
    {
      description:
        'Genuine care about code quality and engineering craft',
    },
    {
      description:
        'Strong fundamentals in at least one area: AI/ML, backend, or mobile',
    },
    {
      description:
        'Comfort with accountability - owning outcomes, not just tasks',
    },
  ],
},

openPositions: {
  heading: 'Open Positions',
  roles: [
    {
      title: 'Digital Marketing Executive',
      subtitle: 'SEO, SMO, Google Ads, Content Strategy',
      meta: 'Exp: 1 to 2 Years',
      position: 'Positions: 2',
      detail: 'Adajan, India',
    },
    {
      title: 'Full Stack Developer',
      subtitle: 'React.js, Node.js',
      meta: 'Exp: 1 to 2 Years',
      position: 'Positions: 2',
      detail: 'Adajan, India',
    },
  ],
},

fintechHeroSection: {
  image: fintech,
  heading: 'AI Automation for Financial Services That Cannot Afford Failure',
},

buildFintechSection: {
  intro:
    'Financial technology operates under intense scrutiny. Regulators watching every transaction. Customers expecting flawless service. Fraudsters probing every vulnerability. The Coding Studio builds AI automation that performs under this pressure-systems designed from the ground up for security, compliance, and scale.',
  introHighlight: 'The Coding Studio',
  heading: 'What We Build In Fintech',
  fintechstep: fintechstep,
  items: [
    {
      number: '01',
      title: 'Fraud Detection & Prevention',
      description: 'ML-powered systems that identify fraudulent patterns in real-time-catching what rule-based approaches miss while minimizing false positives that frustrate legitimate customers. We build models trained on your transaction patterns, continuously learning and adapting to emerging threats.',
    },
    {
      number: '02',
      title: 'Lending Automation',
      description: 'End-to-end loan processing automation: document intake, data extraction, credit scoring, underwriting decisioning, disbursement orchestration. Reduce processing time from days to minutes while maintaining complete audit trails for regulatory compliance.',
    }, 
    {
      number: '03',
      title: 'Payment Processing Systems',
      description: 'High - throughput payment infrastructure designed for reliability and speed. Multi-gateway integration, intelligent routing, automatic reconciliation, comprehensive reporting. PCI-DSS compliant architecture from day one.',
    }, 
    {
      number: '04',
      title: 'KYC/AML Automation',
      description: 'Intelligent identity verification and transaction monitoring. Document authentication, sanctions screening, risk scoring, suspicious activity detection - automated workflows that satisfy regulatory requirements while minimizing manual review burden.',
    },
    {
      number: '05',
      title: 'Regulatory Reporting',
      description: 'Automated generation of compliance reports for RBI, SEBI, and other regulatory bodies. Data aggregation, format validation, submission tracking - ensuring you never miss a deadline & never submit inaccurate data.',
    }, 
  ],
},

technologyStepsCards: [
  {
    num: '01.',
    heading: 'AI & Machine Learning',
    link: '/automation',
    points: [
      'Python, TensorFlow, PyTorch',
      'LangChain, Vector Databases',
      'Hugging Face, Custom Models',
      'MLflow, Kubeflow',
    ],
  },
  {
    num: '02.',
    heading: 'Backend Engineering',
    link: '/backend',
    points: [
      'Node.js, Python, Go',
      'PostgreSQL, MongoDB, Redis',
      'GraphQL, REST',
      'Kafka, RabbitMQ',
    ],
  },
  {
    num: '03.',
    heading: 'Frontend & Mobile',
    link: '/frontend',
    points: [
      'React, Next.js, Vue.js',
      'React Native, Flutter',
      'Swift, Kotlin',
      'TypeScript',
    ],
  },
  {
    num: '04.',
    heading: 'Cloud & Infrastructure',
    link: '/clouddevops',
    points: [
      'AWS, Google Cloud, Azure',
      'Docker, Kubernetes',
      'Terraform, Pulumi',
      'GitHub Actions, GitLab CI',
    ],
  },
  {
    num: '05.',
    heading: 'Database',
    link: '/database',
    points: [
      'PostgreSQL',
      'MongoDB',
      'Redis',
      'Elasticsearch',
    ],
  },
],

approachItems: [
  {
    title: 'Architecture Before Code',
    description: 'We design before we build. Data flows mapped. Integration points identified. Compliance requirements embedded. Scalability paths planned. The time invested in architecture pays dividends throughout the project lifecycle.',
    icon: architecture,
  },
  {
    title: 'Test - Driven Quality',
    description: 'Automated testing is not negotiable. Unit tests, integration tests, endto-end tests - we build quality in from the beginning rather than trying to test it in at the end.',
    icon: test,
  },
  {
    title: 'Security by Design',
    description: 'Security is architectural, not ornamental. Encryption, access controls, audit logging, vulnerability scanning - integrated from day one, not patched on before deployment.',
    icon: security,
  },
  {
    title: 'Documentation Culture',
    description: 'Code that is not documented is not finished. We maintain comprehensive documentation for architecture decisions, API contracts, & operational procedures - because we build systems intended to outlast our engagement.',
    icon: documentation,
  },
],

portfolioSolutionItems: [
  {
    icon: portfolioSolutionIcon,
    text: 'Fully Responsive Web and Mobile Applications',
  },
  {
    icon: portfolioSolutionIcon,
    text: 'Advanced Product Listing & Filtering System',
  },
  {
    icon: portfolioSolutionIcon,
    text: 'Real-Time Order Tracking and Management',
  },
  {
    icon: portfolioSolutionIcon,
    text: 'Expert-Led Live Video Buying Assistance',
  },
  {
    icon: portfolioSolutionIcon,
    text: 'Competitive Price Match & Best Price Guarantee Engine',
  },
  {
    icon: portfolioSolutionIcon,
    text: 'End-to-End Post-Sale Service & Warranty Management (Go Care)',
  },
],

portfolioStatsItems: [
  {
    num: '01',
    title: 'Industry',
    points: ['Fintech', 'Healthcare', 'SaaS'],
  },
  {
    num: '02',
    title: 'Service',
    points: ['Web', 'Mobile', 'AI'],
  },
  {
    num: '03',
    title: 'Scale',
    points: ['Startup', 'Enterprise'],
  },
],

portfolioProjectStatsData: [
  {
    num: '01',
    heading: 'Industry',
    points: ['Fintech', 'Cryptocurrency', 'EdTech'],
  },
  {
    num: '02',
    heading: 'Tag',
    points: ['Multi-Device Shopping Platform with Referral & Rewards System'],
  },
  {
    num: '03',
    heading: 'Tech Used',
    points: ['React.js / Next.js', 'Flutter / React Native', 'MongoDB / AWS'],
  },
],

portfolioFeatureItems: [
  { title: 'Cross-platform experience' },
  { title: 'Smart product search & category filters' },
  { title: 'Referral code system with reward tracking' },
  { title: 'Real-time order updates & status tracking' },
  { title: 'Personalized user dashboard' },
  { title: 'Secure payments integration' },
  { title: 'Clean, modern UI with intuitive navigation' },
  { title: 'Admin control panel for full platform management' },
],

portfolioChallengesPoints: [
  'Ensuring a seamless and consistent user experience across web and mobile platforms',
  'Building a scalable referral system with real- time reward tracking',
  'Managing complex product catalogs with efficient search and filtering',
  'Implementing reliable order tracking and status updates',
  'Maintaining high performance and fast load times across devices',

],

automationItems: [
  { name: 'Make', icon: makeIcon },
  { name: 'Zapier', icon: zapierIcon },
  { name: 'n8n', icon: n8nIcon },
],

cloudDevopsItems: [
  { name: 'AWS', icon: awsIcon },
  { name: 'Azure', icon: azureIcon },
  { name: 'Google Cloud', icon: gcpIcon },
  { name: 'Docker', icon: dockerIcon },
  { name: 'Kubernetes', icon: kubernetesIcon },
  { name: 'Terraform', icon: terraformIcon },
],

backendCards: [
  { title: 'NodeJS', icon: nodeServiceIcon },
  { title: 'Redis', icon: redisIcon },
  { title: 'MongoDB', icon: mongodbIcon },
  { title: 'MySQL', icon: mysqlIcon },
  { title: 'Golang', icon: goServiceIcon },
  { title: 'Firebase', icon: firebaseIcon },
],

databaseIcons: [
  { name: 'MongoDB', icon: mongodbIcon },
  { name: 'MySQL', icon: mysqlIcon },
  { name: 'Firebase', icon: firebaseIcon },
  { name: 'Redis', icon: redisIcon },
],


cryptonaryProjectHighlights: [
  {
    number: '1',
    title: 'Industry',
    items: ['Fintech', 'Cryptocurrency', 'EdTech'],
  },
  {
    number: '2',
    title: 'Tag',
    items: ['Crypto Intelligence', 'Trading Education', 'Market Analytics'],
  },
  {
    number: '3',
    title: 'Tech Used',
    items: ['React Native / Flutter', 'Node.js, Web3 APIs', 'Firebase, REST APIs'],
  },
],

cryptonaryChallengePoints: [
  {
    serial: '01',
    lines: ['Fragmented and unreliable', 'crypto market data'],
  },
  {
    serial: '02',
    lines: ['Lack of user-friendly tools', 'for both beginners and', 'advanced traders'],
  },
  {
    serial: '03',
    lines: ['Difficulty in tracking multiple', 'assets and portfolios in', 'real time'],
  },
  {
    serial: '04',
    lines: ['Limited access to', 'actionable insights and', 'predictive analytics'],
  },
  {
    serial: '05',
    lines: ['Need for seamless integration', 'between learning,', 'tracking, and trading'],
  },
],

cryptonaryOverviewSectionDescription:
  'Cryptonary is a powerful crypto market intelligence platform designed to simplify digital asset tracking and trading. It provides real-time data, advanced analytics, and AI-driven insights to help users stay ahead of market trends. Users can monitor and manage assets like Bitcoin and Ethereum through a clean, intuitive interface. Built for both beginners and experienced traders, it delivers a seamless and secure experience across devices.',

cryptonaryBuiltPointsLeft: [
  'Portfolio management tools',
  'AI-powered insights and trend analysis',
  'Clean, intuitive mobile-first UI for better user engagement',
],

cryptonaryBuiltPointsRight: [
  'Real-time market tracking & analytics',
  'Educational modules for learning crypto trading',
],

cryptonaryWhatWeBuiltPhones: [
  {
    alt: 'What We Built phone screen 1',
    className:
      'w-[180px] lg:w-[210px] xl:w-[250px] 2xl:w-[270px]',
  },
  {
    alt: 'What We Built phone screen 2',
    className:
     'w-[180px] lg:w-[210px] xl:w-[250px] 2xl:w-[270px]',
  },
  {
    alt: 'What We Built phone screen 3',
    className:
      'w-[250px] lg:w-[280px] xl:w-[320px] 2xl:w-[340px]',
  },
  {
    alt: 'What We Built phone screen 4',
    className:
      'w-[180px] lg:w-[210px] xl:w-[250px] 2xl:w-[270px]',
  },
  {
    alt: 'What We Built phone screen 5',
    className:
      'w-[180px] lg:w-[210px] xl:w-[250px] 2xl:w-[270px]',
  },
],

cryptonaryStrategicImpactDescription:
  'The platform significantly enhanced how users interact with the crypto market by delivering real-time insights, streamlined portfolio tracking, and intelligent analytics in one place. As a result, users were able to make faster, more informed trading decisions while reducing dependency on multiple tools. The intuitive experience increased user engagement and retention, while the secure and scalable architecture ensured reliability and trust, positioning the platform for long-term growth in the evolving crypto ecosystem.',

cryptonaryFeatureItems: [
  { text: 'Real-time crypto market analytics' },
  { text: 'Advanced charting and performance tracking' },
  { text: 'Portfolio management dashboard' },
  { text: 'AI-based trading insights & recommendations' },
  { text: 'Learn-to-trade modules and tutorials' },
  { text: 'Smart alerts and notifications' },
  { text: 'Secure authentication and data protection' },
  { text: 'Multi-asset tracking across exchanges' },
  { text: 'Seamless mobile experience' },
],

rabbitxHeroHighlights: [
  {
    title: 'Industry',
    items: ['Fintech', 'Crypto Derivatives', 'Trading'],
  },
  {
    title: 'Tag',
    items: ['Derivatives Trading', 'Mobile-first UX', 'Performance'],
  },
  {
    title: 'Tech Used',
    items: ['React Native', 'Node.js', 'REST APIs'],
  },
],

arbventureHeroHighlights: [
  {
    title: 'Industry',
    items: ['Real Estate', 'Management'],
  },
  {
    title: 'Tag',
    items: ['Smart Property &', 'Site Management', 'Platform'],
  },
  {
    title: 'Tech Used',
    items: ['React.js , Node.js', 'Express.js , MongoDB', 'REST APIs , Firebase', 'AWS (Cloud & Storage)'],
  },
],

arbventureIntroduction: {
  badgeText: 'Introduction',
  description:
    'ARB Venture is a modern PropTech platform designed to simplify and centralize real estate operations. Built for scalability, it helps organizations efficiently manage sites, teams, and workflows through a unified digital ecosystem.',
},

arbventureProblemStatement: {
  badgeText: 'Problem Statement',
  description:
    'Real estate businesses often struggle with fragmented systems to manage sites, brokers, and managers. Tracking ongoing projects, handling requests, and maintaining real-time visibility becomes difficult when operations rely on manual processes or disconnected tools. This leads to delays, poor coordination, and limited decision-making insights.',
},

arbventureObjective: {
  badgeText: 'Objective',
  introText: 'To design and develop a centralized platform that:',
  items: [
    'Streamlines site and team management',
    'Provides real-time operational visibility',
    'Reduces manual coordination efforts',
    'Improves communication and efficiency across roles',
  ],
},

arbventureApproach: {
  badgeText: 'Our Approach',
  description:
    'We focused on creating a dashboard-first experience with a clean and intuitive interface. The platform was designed with role-based access, ensuring that admins, managers, and brokers have tailored views and functionalities.',
  items: [
    'Simplicity in navigation',
    'Data visualization for quick insights',
    'Scalability for growing operations',
    'Seamless experience across web & mobile',
  ],
},

arbventureSolution: {
  badgeText: 'Solution',
  description:
    'We built a comprehensive system that brings all real estate operations into one place. From managing sites to handling user roles and tracking performance, every feature was designed to reduce friction and increase productivity.',
  items: [
    'A centralized dashboard with real-time metrics',
    'Site tracking for ongoing and completed projects',
    'Manager and broker management modules',
    'Request and registration handling system',
    'Notification and communication features',
  ],
},

arbventureKeyFeatures: {
  badgeText: 'Key Features',
  items: [
    { icon: 'site', text: 'Site management' },
    { icon: 'analytics', text: 'Real-time analytics dashboard' },
    { icon: 'users', text: 'Manager & broker control system' },
    { icon: 'lock', text: 'Role-based access and permissions' },
    { icon: 'request', text: 'Request & approval workflows' },
    { icon: 'bell', text: 'Smart notifications and alerts' },
    { icon: 'mobile', text: 'Fully responsive (web + mobile)' },
  ],
},

arbventureImpactResults: {
  badgeText: 'Impact & Results',
  description:
    'ARB Venture transformed how teams manage real estate operations by introducing structure, visibility, and automation. The platform reduced manual workload, improved coordination between teams, and enabled faster, data-driven decisions. Overall, it increased operational efficiency and delivered a smoother management experience.',
  imageText:
    'We believe in giving back. Our team contributes to open source projects and shares knowledge through blog posts, conference talks, and community events.',
},

rabbitxChallengePoints: [
  { serial: '1.', text: 'Complex interfaces that overwhelm users' },
  { serial: '2.', text: 'Slow execution and delayed market data' },
  { serial: '3.', text: 'Poor mobile trading experiences' },
  { serial: '4.', text: 'Limited risk controls & clarity' },
  { serial: '5.', text: 'Hard-to-find insights and key actions' },
],

rabbitxBuiltPoints: [
  { serial: '1.', text: 'Clean trading UI with fast core actions' },
  { serial: '2.', text: 'Real-time price & position tracking' },
  { serial: '3.', text: 'Order placement and management flow' },
  { serial: '4.', text: 'Risk-focused views and trade clarity' },
  { serial: '5.', text: 'Mobile-first layout built for speed' },
],

upskillHero: {
  titleLines: ['Master Tech Skills &', 'Land Your Dream Job'],
  primaryCta: 'Start Learning Today',
  secondaryCta: 'Explore Courses',
  description:
    'Industry leading courses in AI/ML, Full Stack, Backend & Frontend Development. Get job ready in 14-20 weeks with guaranteed placement support.',
  stats: [
    { value: '3,680+', label: 'Students' },
    { value: '92%', label: 'Placement Rate' },
    { value: '4.8/5', label: 'Rating' },
    { value: '₹8-35L', label: 'Avg Package' },
  ],
  pathTitle: 'Choose Your Path to Success',
  pathDescription:
    'Industry-designed courses with hands-on projects, mentorship, and guaranteed placement support.',
},

upskillCourses: [
  {
    id: 'aiml',
    title: 'AI/ML Mastery',
    subtitle: 'Machine Learning & Artificial Intelligence',
    weeks: '20 Weeks',
    level: 'Intermediate to Advanced',
    rating: '4.9',
    masteryPoints: [
      'Deep Learning & Neural Networks',
      'NLP & Computer Vision',
      'MLOps & Model Deployment',
      'Real-world AI Projects',
      'Kaggle Competitions',
    ],
    pkg: '₹12-35 LPA',
    projects: '15+ Projects',
    status: 'FAANG Ready',
  },
  {
    id: 'full-stack',
    title: 'Full Stack Development',
    subtitle: 'React Native + Node.js + DevOps',
    weeks: '20 Weeks',
    level: 'Beginner to Advanced',
    rating: '4.8',
    masteryPoints: [
      'React Native Mobile Development',
      'Node.js Backend Architecture',
      'Cloud Deployment (AWS/Azure)',
      'Microservices & APIs',
      '20+ Full Stack Projects',
    ],
    pkg: '₹8-25 LPA',
    projects: '20+ Projects',
    status: 'Job Ready',
  },
  {
    id: 'backend',
    title: 'Backend Engineering',
    subtitle: 'System Design + Microservices + Cloud',
    weeks: '16 Weeks',
    level: 'Intermediate',
    rating: '4.9',
    masteryPoints: [
      'System Design at Scale',
      'Microservices Architecture',
      'Database Optimization',
      'API Design & Security',
      'Cloud Infrastructure',
    ],
    pkg: '₹10-30 LPA',
    projects: '12+ Projects',
    status: 'Senior Ready',
  },
  {
    id: 'frontend',
    title: 'Frontend Development',
    subtitle: 'React + Next.js + Modern UI/UX',
    weeks: '14 Weeks',
    level: 'Beginner to Intermediate',
    rating: '4.7',
    masteryPoints: [
      'React & Next.js Mastery',
      'Advanced CSS & Animations',
      'Performance Optimization',
      'UI/UX Design Principles',
      '15+ Frontend Projects',
    ],
    pkg: '₹6-20 LPA',
    projects: '15+ Projects',
    status: 'Portfolio Ready',
  },
],

upskillCoursesLabels: {
  masteryHeading: "What You'll Master:",
  package: 'Package',
  projects: 'Projects',
  status: 'Status',
},

upskillExpertise: {
  badge: 'EXPERTISE',
  title: 'Compliance Expertise',
  cards: [
    { title: 'Expert Mentorship', description: 'Learn from industry veterans with 10+ years at FAANG companies' },
    { title: '92% Placement Rate', description: 'Dedicated career support until you land your dream job' },
    { title: 'Hands-on Projects', description: '15-20 real-world projects for your portfolio' },
    { title: 'Lifetime Access', description: 'All course materials, updates, and community forever' },
    { title: 'Flexible Learning', description: 'Learn at your own pace with recorded sessions' },
    { title: 'Interview Prep', description: 'Mock interviews, resume building, and HR training' },
  ],
  ctaTitle: 'Ready to Transform Your Career?',
  ctaDescription: 'Join 3,680+ students who landed their dream tech jobs',
  ctaButton: 'Enroll Now & Get ₹10,000 Off! →',
  ctaFootnote: 'Limited time offer • Only 50 seats left this batch',
},

ddxHero: {
  heading: 'DDX',
  subheading: 'AI-Powered Diagnostic Experience',
  description:
    'Reimagining how people understand symptoms, access care, and make faster health decisions.',
  backgroundAlt: 'DDX background',
},

  
}

/** Home Technology section grid — returns `undefined` when the tile should not navigate. */
export function getTechnologyGridNavigationPath(title: string): string | undefined {
  switch (title) {
    case 'Frontend Development':
      return '/frontend'
    case 'Mobile Development':
      return undefined
    case 'AI & Automation':
      return '/automation'
    case 'Backend Development':
      return '/backend'
    case 'Database':
      return '/database'
    case 'Cloud & devops':
      return '/clouddevops'
    default:
      return undefined
  }
}

/** TechnoDetails pills — returns `undefined` when the pill should not navigate. */
export function getTechnoDetailNavigationPath(service: string): string | undefined {
  switch (service) {
    case 'Frontend Development':
      return '/frontend'
    case 'Backend Development':
      return '/backend'
    case 'Mobile Development':
      return undefined
    case 'Database':
      return '/database'
    case 'Cloud & DevOps':
      return '/clouddevops'
    case 'AI & Automation':
      return '/automation'
    default:
      return undefined
  }
}

export function isTechnoDetailServiceActiveForPath(service: string, pathname: string): boolean {
  switch (pathname) {
    case '/frontend':
      return service === 'Frontend Development'
    case '/backend':
      return service === 'Backend Development'
    case '/database':
      return service === 'Database'
    case '/clouddevops':
      return service === 'Cloud & DevOps'
    case '/automation':
      return service === 'AI & Automation'
    default:
      return false
  }
}

export default Constants;
